export const isArray = (s) =>
  s !== null && typeof s !== "undefined" && s.constructor === Array;

export const isSomething = (s) => s !== null && typeof s !== "undefined";
